// FirmaAdendum.utils.ts

import type { FirmaAdendumTramite } from "../types";

export interface FirmaAdendumRow {
  _id: string;
  noTramite: string;
  cedula: string;
  modoFirmantes: string;
  estado: string;
  linkFirmante: string;
  rutaPdf: string | null;
  fechaCreacion: string;
  fechaActualizacion: string;
}

const toOptionalString = (value: unknown): string =>
  typeof value === "string" ? value : "";

export const buildFirmaAdendumRow = (
  tramite: FirmaAdendumTramite,
  index: number,
): FirmaAdendumRow => ({
  _id: `${tramite.no_tramite || index}-${index}`,
  noTramite: toOptionalString(tramite.no_tramite),
  cedula: toOptionalString(tramite.cedula),
  modoFirmantes: toOptionalString(tramite.modo_firmantes),
  estado: toOptionalString(tramite.estado),
  linkFirmante: toOptionalString(tramite.link_firmante),
  rutaPdf: typeof tramite.ruta_pdf === "string" ? tramite.ruta_pdf : null,
  fechaCreacion: toOptionalString(tramite.fecha_creacion),
  fechaActualizacion: toOptionalString(tramite.fecha_actualizacion),
});

export const FIRMA_ESTADO_LABELS: Record<string, string> = {
  creado: "Creado",
  error_creacion: "Error de creación",
  firmado: "Firmado",
  documento_guardado: "Documento guardado",
  bloqueado_dactilar: "Bloqueado dactilar",
  bloqueado_biometria: "Bloqueado biometría",
  rechazado_consentimiento: "Rechazado consentimiento",
  caducado: "Caducado",
  biometria_exitosa: "Biometría exitosa",
};

export const FIRMA_ESTADO_COLORS: Record<string, "success" | "error" | "warning" | "info" | "default"> = {
  creado: "info",
  error_creacion: "error",
  firmado: "success",
  documento_guardado: "success",
  bloqueado_dactilar: "error",
  bloqueado_biometria: "error",
  rechazado_consentimiento: "warning",
  caducado: "warning",
  biometria_exitosa: "success",
};

export const firmaEstadoLabel = (estado: string): string =>
  FIRMA_ESTADO_LABELS[estado] ?? estado;

export const firmaEstadoColor = (
  estado: string,
): "success" | "error" | "warning" | "info" | "default" =>
  FIRMA_ESTADO_COLORS[estado] ?? "default";
